// src/utils/consoleFilter.js
// Console filtering utility for Firebase connection messages

export const setupConsoleFilter = () => {
  // Store original console methods
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const originalConsoleLog = console.log;

  // Filter Firebase connection messages
  console.error = (...args) => {
    const message = args.join(' ');
    
    // Filter out Firebase connection termination messages
    if (message.includes('net::ERR_BLOCKED_BY_CLIENT') && 
        message.includes('firestore.googleapis.com') &&
        message.includes('TYPE=terminate')) {
      return; // Don't log these
    }
    
    // Filter out other Firebase connection messages
    if (message.includes('firestore.googleapis.com') && 
        (message.includes('Listen/channel') || message.includes('terminate'))) {
      return; // Don't log these
    }
    
    // Log other errors normally
    originalConsoleError.apply(console, args);
  };

  console.warn = (...args) => {
    const message = args.join(' ');
    
    // Filter out Firebase connection warnings
    if (message.includes('firestore.googleapis.com') && 
        message.includes('connection')) {
      return; // Don't log these
    }
    
    // Log other warnings normally
    originalConsoleWarn.apply(console, args);
  };

  console.log = (...args) => {
    const message = args.join(' ');
    
    // Filter out Firebase connection logs
    if (message.includes('firestore.googleapis.com') && 
        message.includes('Listen/channel')) {
      return; // Don't log these
    }
    
    // Log other messages normally
    originalConsoleLog.apply(console, args);
  };

  // Restore original console methods on page unload
  window.addEventListener('beforeunload', () => {
    console.error = originalConsoleError;
    console.warn = originalConsoleWarn;
    console.log = originalConsoleLog;
  });

  // Return cleanup function
  return () => {
    console.error = originalConsoleError;
    console.warn = originalConsoleWarn;
    console.log = originalConsoleLog;
  };
};

// Auto-setup when imported
setupConsoleFilter();
